export const FETCH_ALL_PARTNERS = "FETCH_ALL_PARTNERS";
export const FETCH_PARTNER = "FETCH_PARTNER";
export const CREATE_PARTNER = "CREATE_PARTNER";
export const UPDATE_PARTNER = "UPDATE_PARTNER";
export const DELETE_PARTNER = "DELETE_PARTNER";
